import { gql } from 'apollo-boost'
import { ID } from '../id.type'

export interface QuoteDownloadVariables {
  id: ID
  accessKey?: string
}

export interface QuoteDownloadData {
  base64: string
}

export const QUOTE_DOWNLOAD_QUERY = gql`
  query download($id: ID!, $accessKey: String) {
    base64: getQuotePdfById(id: $id, accessKey: $accessKey)
  }
`
